wbApp.controller('UserRolesDetailCtrl', ['$scope', 'userRolesSvc', 'tenantSettingSvc',
function ($scope, userRolesSvc, tenantSettingSvc) {

    userRolesSvc.extendWithRfidSchedule($scope.model);

    $scope.modelOrig = angular.copy($scope.model);

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        userRolesSvc.save(data, success, error);

        function success() {
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.accessType = $scope.model.rfidAccessGroup.rfidAccessGroupID >= 253
        ? $scope.model.rfidAccessGroup.rfidAccessGroupID
        : 0;

    $scope.onAccessTypeChange = function (accessType) {
        if (accessType >= 253) {
            $scope.model.rfidAccessGroup.rfidAccessGroupID = accessType;
        } else {
            if ($scope.modelOrig.rfidAccessGroup.rfidAccessGroupID < 253) {
                $scope.model.rfidAccessGroup.rfidAccessGroupID = $scope.modelOrig.rfidAccessGroup.rfidAccessGroupID;
            } else {
                $scope.model.rfidAccessGroup.rfidAccessGroupID = 0;
            }
        }
    }

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "users/user-roles-detail-main-tab.html"
        },{
            title: "TXT_ADMIN_SECURITY",
            template: "users/user-roles-detail-admin-security-tab.html",
            paneScrollable: true
        },{
            title: "TXT_CLIENT_SECURITY",
            template: "users/user-roles-detail-client-security-tab.html",
            paneScrollable: true
        }
    ];

    if (tenantSettingSvc.settings.enableRfidAccessGroups) {
        $scope.detailTabs.push({
            title: 'TXT_RFID_ACCESS_GROUP_TITLE',
            template: "users/user-roles-detail-rfid-access-group-tab.html"
        });
    }

    $scope.detailTabs.activeTab = 0;

}]);
